import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { ReactComponent as ConfirmIcon } from '../../../assets/svg/ConfirmIcon.svg';
import { createNewPitanje, editPitanje, getPitanjeById } from '../../../server/server-kategorije-tree';
import { notif } from '../../utils/util';
import Loading from '../../../utils/Loading';
import DropDownStrings from '../../DropDownStrings';
import { TezinaPitanja } from '../../../model/enum/tezina-pitanja.enum';
import ImagesForm from '../../media/ImagesForm';
import MDEditor from '@uiw/react-md-editor';

type Inputs = {
    naziv: string;
    opis: string;
    odgovor: string;
    tags: string[];
    tezina: string;
    redosled: number | undefined;
    visible: boolean;
};

const keysArray: string[] = Object.keys(TezinaPitanja).filter((key: any) => isNaN(key));

function AddPitanjeModal({ modalIsOpen, closeModal, lekcija, pitanjeId, reloadLekcije }: any) {
    const [errorMessage, setErrorMessage] = useState('');
    const [pitanje, setPitanje] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const [tezina, setTezina] = useState('Select');
    const [tags, setTags] = useState<string[]>([]);
    const [visible, setVisible] = useState(true);
    const [imagesList, setImagesList] = useState<any>([]);
    const {
        register,
        handleSubmit,
        watch,
        getValues,
        setValue,
        reset,
        formState: { errors },
        control,
    } = useForm<Inputs>({
        defaultValues: {
            naziv: '',
            opis: '',
            odgovor: '',
            tezina: '',
            redosled: 0,
        },
    });

    useEffect(() => {
        if (!!pitanjeId) loadPitanje();
    }, [pitanjeId]);

    const loadPitanje = async () => {
        const resp = await getPitanjeById(pitanjeId);
        if (resp.status == 200) {
            setPitanje(resp.data);
        }
    };

    useEffect(() => {
        if (modalIsOpen) {
            ReactModal.setAppElement('#root');
        }
    }, [modalIsOpen]);

    useEffect(() => {
        if (!!pitanje?.id) {
            console.log('here');
            setValue('naziv', pitanje.naziv);
            setValue('opis', pitanje.opis);
            setValue('odgovor', pitanje.odgovor);
            setValue('tezina', TezinaPitanja[pitanje.tezina]);
            setValue('redosled', pitanje.redosled);
            setVisible(pitanje?.visible);
            setTezina(TezinaPitanja[pitanje.tezina]);
            if (pitanje.oblastImages?.length) setImagesList(reorderImages(pitanje.oblastImages));
        }
    }, [pitanje]);
    const onSubmit: SubmitHandler<Inputs> = async () => {
        if (!!pitanje?.id) updatePitanje();
        else {
            createPitanje();
        }
    };
    const createPitanje = async () => {
        setLoading(true);
        let data: any = getValues();
        data.redosled = getValues('redosled')?.toString();
        data.lekcijaId = lekcija?.id;
        data.tags = tags;
        data.visible = visible;
        if (imagesList.length) data.files = imagesList;
        const resp = await createNewPitanje(data);
        if (resp.status == 201) {
            reloadLekcije();
            notif('Uspešno ste kreirali novo pitanje!');
            setLoading(false);
            closeModal();
        } else {
            setLoading(false);
        }
    };
    const updatePitanje = async () => {
        setLoading(true);
        let data: any = getValues();
        data.id = pitanje?.id;
        data.redosled = getValues('redosled')?.toString();
        data.lekcijaId = lekcija?.id;
        data.tags = tags;
        data.visible = visible;
        console.log('images list ', imagesList);
        if (imagesList.length > 0) {
            data.files = imagesList;
        }
        const resp = await editPitanje(data);
        if (resp.status == 201) {
            reloadLekcije();
            notif('Uspešno ste izmenili pitanje!');
            setLoading(false);
            closeModal();
        } else {
            setLoading(false);
        }
    };

    const reorderImages = (files: any) => {
        return !!files.length
            ? files.map((item: any) => {
                  return { id: item?.image?.id, redosled: item?.redosled };
              })
            : [];
    };

    const setSelectedTezina = (item: any) => {
        setValue('tezina', item, { shouldValidate: true });
        setTezina(!!item ? item : 'Select');
    };
    const changeVisibilty = () => {
        setVisible((prev) => !prev);
    };

    return (
        <ReactModal
            ariaHideApp={false}
            isOpen={modalIsOpen}
            onAfterOpen={() => {}}
            onAfterClose={() => {
                reset();
                setTezina('Select');
                setVisible(true);
                setImagesList([]);
                setPitanje(null);
            }}
            onRequestClose={closeModal}
            className="no-scroll"
            style={{
                overlay: {
                    zIndex: 5,
                    backdropFilter: 'brightness(30%)',
                },
                content: {
                    padding: 0,
                    opacity: 1,
                    width: 1000,
                    margin: 'auto',
                    backgroundColor: 'transparent',
                    height: '100%',
                    maxHeight: '100%',
                    border: 'none',
                    boxShadow: 'none',
                    overflow: 'auto',
                    paddingTop: 15,
                    paddingBottom: 15,
                },
            }}
        >
            <div className="   max-h-[600px] w-full  ">
                <form
                    className="flex flex-col items-center w-full bg-white px-[40px] py-[30px] rounded-[10px]"
                    onSubmit={handleSubmit(onSubmit)}
                    autoComplete="off"
                >
                    <div className="flex flex-col w-full">
                        <label className="text-[16px] leading-5 text-black700 font-bold  ">Naziv pitanja</label>

                        <Controller
                            control={control}
                            name="naziv"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <MDEditor value={field.value} onChange={(value: any) => setValue('naziv', value, { shouldValidate: true })} preview="edit" />
                            )}
                        />

                        <p className="text-redError text-[12px] leading-5 h-5 ">
                            <span>{errors.naziv?.type === 'required' ? 'Obavezno popunite ovo polje!' : ''} </span>
                        </p>
                    </div>
                    <div className="flex flex-col w-full">
                        <label className="text-[16px] leading-5 text-black700 font-bold  ">Odgovor</label>
                        <Controller
                            control={control}
                            name="odgovor"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <MDEditor value={field.value} onChange={(value: any) => setValue('odgovor', value, { shouldValidate: true })} preview="edit" />
                            )}
                        />
                        <p className="text-redError text-[12px] leading-5 h-5 ">
                            <span>{errors.odgovor?.type === 'required' ? 'Obavezno popunite ovo polje!' : ''} </span>
                        </p>
                    </div>
                    <div className="flex flex-col w-full">
                        <label className="text-[16px] leading-5 text-black700 font-bold  ">Opis pitanja</label>
                        <Controller
                            control={control}
                            name="opis"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <MDEditor value={field.value} onChange={(value: any) => setValue('opis', value, { shouldValidate: true })} preview="edit" />
                            )}
                        />
                        <p className="text-redError text-[12px] leading-5 h-5 ">
                            <span>{errors.opis?.type === 'required' ? 'Obavezno popunite ovo polje!' : ''} </span>
                        </p>
                    </div>
                    <ImagesForm imagesList={imagesList} setImagesList={setImagesList} />
                    <div className="mt-4 w-full">
                        <DropDownStrings
                            list={keysArray}
                            register={register}
                            registerField="tezina"
                            errors={errors.tezina?.type}
                            label="Težina pitanja"
                            selectedValue={tezina}
                            setSelectedValue={setSelectedTezina}
                        />
                    </div>
                    <div className="flex flex-col w-full">
                        <label className="text-[16px] leading-5 text-black700 font-bold  ">Redosled pitanja</label>
                        <div className="bg-white border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center ">
                            <input
                                className="text-[16px] leading-5 text-black700  w-full outline-none  placeholder:text-black200 "
                                placeholder="Redosled pitanja"
                                type="number"
                                {...register('redosled', {
                                    min: 0,
                                })}
                            />
                        </div>
                        <p className="text-redError text-[12px]  leading-5 h-5 ">
                            <span>{errors.redosled?.type === 'min' ? 'Vrednost mora biti pozitivan broj!' : ''} </span>
                        </p>
                    </div>
                    <div className="w-full">
                        <div className={`flex flex-row items-center cursor-pointer my-2`}>
                            <div
                                className="border-[1.5px] border-black rounded-full h-[18px] w-[18px] flex items-center justify-center"
                                onClick={() => changeVisibilty()}
                            >
                                {visible && <div className="rounded-full h-[10px] w-[10px] bg-black"></div>}
                            </div>
                            <label className="text-black text-[16px] font-medium ml-[13px] cursor-pointer not-selectable">Course visible</label>
                        </div>
                    </div>
                    <p className="text-redError text-[12px] leading-5 h-5 ">{!!errorMessage ? errorMessage : ''}</p>
                    <div className="w-full flex flex-row gap-5 justify-end">
                        <button
                            className={`px-5 h-[48px] flex items-center justify-center bg-white border border-black200 rounded-[4px] text-[18px] text-black700 font-bold cursor-pointer`}
                            onClick={(e) => {
                                e.preventDefault();
                                closeModal();
                            }}
                        >
                            <p>Otkaži</p>
                        </button>
                        <button
                            type="submit"
                            className={`px-5 h-[48px] flex items-center justify-center bg-white border border-black200 rounded-[4px] text-[18px] text-black700 font-bold cursor-pointer`}
                            disabled={loading}
                        >
                            {loading ? (
                                <Loading size={25} />
                            ) : (
                                <div className="w-full flex flex-row items-center justify-center gap-3">
                                    <ConfirmIcon />
                                    <p>Potvrdi</p>
                                </div>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </ReactModal>
    );
}

export default AddPitanjeModal;
